import { IForm, State, Sorting, SortDirection, ComponentBase } from 'app/shared/lib/essette-site';
import { bindable } from 'aurelia-typed-observable-plugin';
import { autoinject } from 'aurelia-framework';
import { apiCall } from 'app/shared/lib/api/api';
import { IPopup } from 'app/shared/elements/popup-base';
import { validate } from 'app/shared/elements/ess-rule';
import { IQueryLoadOptions } from 'app/shared/lib/api/api-types';
import { AdmissionCareDayService } from 'app/um/services/admission-care-day-service';
import { SaveStatusHistory } from 'app/um/components/auth/admission/post-service/save-status-history';
import * as UM from 'app/um/models/essette-api';
import { FormSuccessCustomEvent } from 'app/shared/elements/forms/ess-form';

@autoinject()
export class CareDayStatusHistory extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable.object protected careDay: UM.AdmissionCareDay = { id: null };
    @bindable.boolean protected showActions: boolean = false;

    protected statusHistories: UM.AdmissionCareDayStatusHistory[] = [];

    protected validate = validate;

    ////****************** Element References ***************************************////
    protected $statusHistoryForm!: IForm;
    protected $saveStatusHistory!: SaveStatusHistory;
    protected $statusHistoryModal!: IPopup;

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        public state: State,
        private readonly admissionCareDayService: AdmissionCareDayService,
        ...rest: any[]) {
        super(...rest)
    }

    ////****************** Events ***************************************************////
    protected async careDayChanged(): Promise<void> {
        this.statusHistories = [];
        await this.loadStatusHistory();
    }

    protected formSuccess({ detail }: FormSuccessCustomEvent): void {
        this.$statusHistoryModal.close();
        if(detail.form.reset) detail.form.reset();
        this.statusHistories = [];
        this.loadStatusHistory();
    }

    ////****************** Functions ************************************************////
    protected edit(statusHistory: UM.AdmissionCareDayStatusHistory): void {
        if(!(statusHistory && statusHistory.metadata && statusHistory.metadata.started && statusHistory.metadata.started.timestamp)) {
            return;
        }

        this.statusHistories = [statusHistory];
    }

    protected editStatusHistory(statusHistory: UM.AdmissionCareDayStatusHistory): void {
        this.$saveStatusHistory.statusHistory = statusHistory

        this.$statusHistoryModal.open()
    }

    ////****************** Service Calls ********************************************////

    ////****************** IForm ****************************************************////
    public hasChanges(): boolean {
        throw new Error('Method not implemented.');
    }

    public async submit(): Promise<boolean> {
        return this.$statusHistoryForm.submit();
    }

    public reset(): void {
        this.statusHistories = [];
        this.careDayChanged();
    }

    ////****************** Service Calls ********************************************////
    @apiCall
    private async loadStatusHistory(): Promise<void> {
        if(!this.careDay.id) return;

        try {
            this.state.beginLoad();
            const sorting: Sorting = new Sorting();
            sorting.add({
                reference: 'metadata.started.timestamp',
                direction: SortDirection.Ascending
            });

            const options: Partial<IQueryLoadOptions> = {
                all: true,
                sorting: sorting,
                includeInactive: true
            };

            const includes: string[] = [
                'audit.start',
                'metadata.started.byUser',
                'metadata.effectiveOverridden.byUser',
                'status',
                'status.reasons',
                'turnAroundTime'
            ];

            const fields: string[] = [
                'audit.start.timestamp',
                'dueDateTime',
                'effectiveDateTime',
                'metadata.effectiveOverridden.byUser.description',
                'metadata.effectiveOverridden.timestamp',
                'metadata.ended.timestamp',
                'metadata.started.byUser.description',
                'status.description',
                'status.reasons.description',
                'turnAroundTime.unit',
                'turnAroundTime.value',
                'status.flag.allowStatusDateEdit'
            ];

            const response = await this.admissionCareDayService.loadCareDayStatusHistory(this.careDay.id, options, includes, fields);
            this.statusHistories = response.results;
        }
        catch(error) {
            throw error;
        }
        finally {
            this.state.endLoad();
        }
    }
}
